"use client"

import React from "react";
import { FormattedMessage } from "react-intl";
import Image from "next/image";
import dayjs from "dayjs";
import { FaUser, FaCalendarDays } from "react-icons/fa6";

const BlogStart = ({ allPosts }) => (
  <section id="blog" className="pt-[110px] pb-[60px]">
    <div className="container">
      <div className="mx-auto mb-14 max-w-[690px] text-center lg:mb-[70px]">
        <h2 className="mb-4 text-3xl font-bold text-black dark:text-white sm:text-4xl md:text-[44px] md:leading-tight">
          <FormattedMessage
            id="home-page-latest-news-and-blogs-title"
          />
        </h2>
        <p className="text-base text-body">
          <FormattedMessage
            id="home-page-latest-news-and-blogs-description"
          />
        </p>
      </div>
    </div>

    <div className="container overflow-hidden lg:max-w-[1250px]">
      <div className="-mx-4 flex flex-wrap justify-center md:-mx-7 lg:-mx-5 xl:-mx-[35px]">
        {allPosts?.map((post, index) => (
          <div
            key={index}
            className="w-full px-4 md:w-1/2 md:px-7 lg:w-1/3 lg:px-5 xl:px-[35px]"
          >
            <a
              href={`https://blog.downfor.life/posts/${post?.slug}`}
              alt={`Link to the post "${post?.title}"`}
              title={`Link to the post "${post?.title}"`}
              target="_blank"
            >
              <div className="mb-10">
                <div className="relative overflow-hidden rounded-sm max-w-[360px] max-h-[200px]">
                  <Image
                    src={post?.coverImage}
                    width={400}
                    height={400}
                    alt="Blog Post Cover Image"
                    title="Blog Post Cover Image"
                    className="w-full h-full object-cover object-center w-full rounded-lg"
                  />
                  <div
                    className="absolute top-0 left-0 flex h-full w-full justify-around bg-gradient-to-b from-transparent via-[#f55c00]/[0.25] to-[#f55c00] pointer-events-none items-end px-[18px] py-4"
                  >
                    <div className="flex flex-wrap">
                      <p className="mt-3 flex items-center justify-center px-[10px] text-base font-medium text-white">
                        <span className="mr-2">
                          <FaUser />
                        </span>
                        {post?.author?.name}
                      </p>

                      <p className="mt-3 flex items-center px-[10px] text-base font-medium text-white">
                        <span className="mr-2">
                          <FaCalendarDays />
                        </span>
                        {dayjs(post?.date).format('MM/YYYY')}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="mt-[30px]">
                  <h3
                    className="inline-block mb-3 text-xl font-semibold text-black hover:text-primary sm:text-2xl lg:text-xl xl:text-2xl"
                  >
                    {post?.title}
                  </h3>
                  <p className="text-base text-body">
                    {post?.description}
                  </p>
                </div>
              </div>
            </a>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default BlogStart;